module.exports = __webpack_public_path__ + "img/eq-armor.37246365.png";